export const userSettingsScope = {
  APPEARANCE: 'APPEARANCE',
  FIXED_ATTRIBUTES: 'FIXED_ATTRIBUTES',
  UPLOAD_PRESETS: 'UPLOAD_PRESETS',
  DEFAULT_FILTERS: 'DEFAULT_FILTERS',
  DASHBOARD_LAYOUT: 'DASHBOARD_LAYOUT',
  TABLE_COLUMN_ORDER: 'TABLE_COLUMN_ORDER',
  TABLE_SORT: 'TABLE_SORT',
  PROJECT_SELECTION: 'PROJECT_SELECTION',
};

export function getTableColumnOrder(
  folderType,
  subtree,
  subFolderType = null,
  identifier = null
) {
  return [
    ..._generateScope(
      folderType,
      subtree,
      subFolderType,
      identifier,
      userSettingsScope.TABLE_COLUMN_ORDER
    ),
  ].join(':');
}

export function getTableSorting(
  folderType,
  subtree,
  subFolderType = null,
  identifier = null
) {
  return [
    ..._generateScope(
      folderType,
      subtree,
      subFolderType,
      identifier,
      userSettingsScope.TABLE_SORT
    ),
  ].join(':');
}

function* _generateScope(
  folderType,
  subtree,
  subFolderType = null,
  identifier = null,
  rootScope
) {
  yield rootScope;

  if (folderType != null) {
    yield 'FOLDER';
    yield folderType;

    if (identifier != null) {
      yield 'UNIQUE';
      yield identifier;
    }

    if (subFolderType != null) {
      yield 'LISTING';
      yield subFolderType;
    }
  } else if (subtree) {
    yield 'SUBTREE';
  }
}
